(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8119],{

/***/ 7885:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Breadcrumbs_Breadcrumbs; }
});

// UNUSED EXPORTS: styles

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(41451);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(45987);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/node_modules/react-is/index.js
var react_is = __webpack_require__(65122);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js + 1 modules
var withStyles = __webpack_require__(40922);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/colorManipulator.js
var colorManipulator = __webpack_require__(59693);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/createSvgIcon.js + 1 modules
var createSvgIcon = __webpack_require__(594);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/internal/svg-icons/MoreHoriz.js


/**
 * @ignore - internal component.
 */

/* harmony default export */ var MoreHoriz = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/react.createElement("path", {
  d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'MoreHoriz'));
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ButtonBase/ButtonBase.js + 4 modules
var ButtonBase = __webpack_require__(41810);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Breadcrumbs/BreadcrumbCollapsed.js









var styles = function styles(theme) {
  return {
    root: {
      display: 'flex',
      marginLeft: theme.spacing(0.5),
      marginRight: theme.spacing(0.5),
      backgroundColor: theme.palette.grey[100],
      color: theme.palette.grey[700],
      borderRadius: 2,
      cursor: 'pointer',
      '&:hover, &:focus': {
        backgroundColor: theme.palette.grey[200]
      },
      '&:active': {
        boxShadow: theme.shadows[0],
        backgroundColor: (0,colorManipulator/* emphasize */._4)(theme.palette.grey[200], 0.12)
      }
    },
    icon: {
      width: 24,
      height: 16
    }
  };
};
/**
 * @ignore - internal component.
 */


function BreadcrumbCollapsed(props) {
  var classes = props.classes,
      other = (0,objectWithoutProperties/* default */.Z)(props, ["classes"]);

  return /*#__PURE__*/react.createElement(ButtonBase/* default */.Z, (0,esm_extends/* default */.Z)({
    component: "li",
    className: classes.root,
    focusRipple: true
  }, other), /*#__PURE__*/react.createElement(MoreHoriz, {
    className: classes.icon
  }));
}

 false ? 0 : void 0;
/* harmony default export */ var Breadcrumbs_BreadcrumbCollapsed = ((0,withStyles/* default */.Z)(styles, {
  name: 'PrivateBreadcrumbCollapsed'
})(BreadcrumbCollapsed));
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Breadcrumbs/Breadcrumbs.js










var Breadcrumbs_styles = {
  /* Styles applied to the root element. */
  root: {},

  /* Styles applied to the ol element. */
  ol: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    padding: 0,
    margin: 0,
    listStyle: 'none'
  },

  /* Styles applied to the li element. */
  li: {},

  /* Styles applied to the separator element. */
  separator: {
    display: 'flex',
    userSelect: 'none',
    marginLeft: 8,
    marginRight: 8
  }
};

function insertSeparators(items, className, separator) {
  return items.reduce(function (acc, current, index) {
    if (index < items.length - 1) {
      acc = acc.concat(current, /*#__PURE__*/react.createElement("li", {
        "aria-hidden": true,
        key: "separator-".concat(index),
        className: className
      }, separator));
    } else {
      acc.push(current);
    }

    return acc;
  }, []);
}

var Breadcrumbs = /*#__PURE__*/react.forwardRef(function Breadcrumbs(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'nav' : _props$component,
      _props$expandText = props.expandText,
      expandText = _props$expandText === void 0 ? 'Show path' : _props$expandText,
      _props$itemsAfterColl = props.itemsAfterCollapse,
      itemsAfterCollapse = _props$itemsAfterColl === void 0 ? 1 : _props$itemsAfterColl,
      _props$itemsBeforeCol = props.itemsBeforeCollapse,
      itemsBeforeCollapse = _props$itemsBeforeCol === void 0 ? 1 : _props$itemsBeforeCol,
      _props$maxItems = props.maxItems,
      maxItems = _props$maxItems === void 0 ? 8 : _props$maxItems,
      _props$separator = props.separator,
      separator = _props$separator === void 0 ? '/' : _props$separator,
      other = (0,objectWithoutProperties/* default */.Z)(props, ["children", "classes", "className", "component", "expandText", "itemsAfterCollapse", "itemsBeforeCollapse", "maxItems", "separator"]);

  var _React$useState = react.useState(false),
      expanded = _React$useState[0],
      setExpanded = _React$useState[1];

  var renderItemsBeforeAndAfter = function renderItemsBeforeAndAfter(allItems) {
    var handleClickExpand = function handleClickExpand(event) {
      setExpanded(true); // The clicked element received the focus but gets removed from the DOM.
      // Let's keep the focus in the component after expanding.

      var focusable = event.currentTarget.parentNode.querySelector('a[href],button,[tabindex]');

      if (focusable) {
        focusable.focus();
      }
    }; // This defends against someone passing weird input, to ensure that if all
    // items would be shown anyway, we just show all items without the EllipsisItem


    if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) {
      if (false) {}

      return allItems;
    }

    return [].concat((0,toConsumableArray/* default */.Z)(allItems.slice(0, itemsBeforeCollapse)), [/*#__PURE__*/react.createElement(Breadcrumbs_BreadcrumbCollapsed, {
      "aria-label": expandText,
      key: "ellipsis",
      onClick: handleClickExpand
    })], (0,toConsumableArray/* default */.Z)(allItems.slice(allItems.length - itemsAfterCollapse, allItems.length)));
  };

  var allItems = react.Children.toArray(children).filter(function (child) {
    if (false) {}

    return /*#__PURE__*/react.isValidElement(child);
  }).map(function (child, index) {
    return /*#__PURE__*/react.createElement("li", {
      className: classes.li,
      key: "child-".concat(index)
    }, child);
  });
  return /*#__PURE__*/react.createElement(Typography/* default */.Z, (0,esm_extends/* default */.Z)({
    ref: ref,
    component: Component,
    color: "textSecondary",
    className: (0,clsx_m/* default */.Z)(classes.root, className)
  }, other), /*#__PURE__*/react.createElement("ol", {
    className: classes.ol
  }, insertSeparators(expanded || maxItems && allItems.length <= maxItems ? allItems : renderItemsBeforeAndAfter(allItems), classes.separator, separator)));
});
 false ? 0 : void 0;
/* harmony default export */ var Breadcrumbs_Breadcrumbs = ((0,withStyles/* default */.Z)(Breadcrumbs_styles, {
  name: 'MuiBreadcrumbs'
})(Breadcrumbs));

/***/ }),

/***/ 68214:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/insurance",
      function () {
        return __webpack_require__(58397);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 25384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports encodeImageUrl, seoKeys, emptySeo */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _createImageApiUrl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12104);




var encodeImageUrl = function(baseUrl, params) {
    // Remove double slashes from the URL path (except for the protocol part)
    var correctedBaseUrl = baseUrl.replace(/([^:]\/)\/+/g, "$1");
    var queryString = Object.keys(params).map(function(key) {
        return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(params[key]));
    }).join("&");
    return "".concat(correctedBaseUrl, "?").concat(queryString);
};
var seoKeys = {
};
for(var key in seoKeys){
    seoKeys[key] = encodeURIComponent(seoKeys[key].replace(/\/\[.+/, "").replace("/", "").replace(/-/g, " "));
}
var emptySeo = {
    title: " ",
    description: "",
    keywords: ""
};
var SeoMetaData = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: data && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
            title: data.title,
            description: data.description || "",
            additionalMetaTags: [
                {
                    name: "title",
                    content: data.title
                },
                {
                    name: "keywords",
                    content: data.keywords
                },
                {
                    name: "description",
                    content: data.description
                }, 
            ],
            openGraph: {
                title: data.title,
                description: data.description || "",
                images: data.image ? [
                    {
                        url: (0,_createImageApiUrl__WEBPACK_IMPORTED_MODULE_3__/* .createImageApiUrl */ .h)(data.image.imageUrl),
                        alt: data.image.alt,
                        width: 1200,
                        height: 630
                    }, 
                ] : []
            },
            noindex: data.noIndex,
            nofollow: data.noIndex
        })
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(SeoMetaData));


/***/ }),

/***/ 12104:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ createImageApiUrl; }
/* harmony export */ });
function createImageApiUrl(originalUrl) {
    var baseUrl = "https://www.mazda.co.il";
    var apiUrl = "https://api.mazda.co.il";
    if (!baseUrl || !apiUrl) {
        throw new Error("Environment variables ORIGIN and API_URL must be set");
    }
    // Extract the relative path from the original URL
    var relativePath = originalUrl.replace(apiUrl, "");
    // Construct the API URL
    return "".concat(baseUrl, "/api/ogimage").concat(encodeURI(relativePath));
}


/***/ }),

/***/ 87183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ popups_ErrorInFormPopup; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./theme/colors.ts
var colors = __webpack_require__(22038);
;// CONCATENATED MODULE: ./reusable/icons/ErrorPopIcon.tsx






var SvgComponent = function(_param) {
    var _color = _param.color, color = _color === void 0 ? colors/* default.black */.Z.black : _color, props = (0,_object_without_properties/* default */.Z)(_param, [
        "color"
    ]);
    var w = 77;
    var h = 77;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 ".concat(w, " ").concat(h),
        width: w,
        height: h,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1.50003 67.5829C1.50321 66.2686 1.80425 64.9845 2.36588 63.8591L33.1659 4.50703C33.1662 4.50638 33.1665 4.50573 33.1669 4.50508C33.7416 3.41226 34.5413 2.52598 35.4763 1.9184C36.4102 1.31147 37.4511 1 38.5 1C39.5489 1 40.5898 1.31147 41.5237 1.9184C42.4585 2.52588 43.2582 3.41196 43.8328 4.50453C43.8333 4.50536 43.8337 4.5062 43.8341 4.50703L74.6309 63.8526C74.632 63.8549 74.6331 63.8571 74.6342 63.8594C75.1958 64.9846 75.4968 66.2687 75.5 67.5829C75.5032 68.8997 75.2072 70.1884 74.6488 71.3192C74.0906 72.4498 73.2943 73.3741 72.353 74.0134C71.4152 74.6504 70.3629 74.9852 69.2995 75H7.70053C6.63714 74.9852 5.58483 74.6504 4.647 74.0134C3.70572 73.3741 2.90944 72.4498 2.35117 71.3192C1.79277 70.1884 1.49683 68.8997 1.50003 67.5829Z",
                stroke: color,
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M38.9492 26.1016L38.9492 53.1016",
                stroke: color,
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M38.9492 59.2031H38.9856",
                stroke: color,
                strokeWidth: "6",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
};
/* harmony default export */ var ErrorPopIcon = (SvgComponent);

// EXTERNAL MODULE: ./reusable/popups/ClassicPopUp.tsx
var ClassicPopUp = __webpack_require__(66395);
;// CONCATENATED MODULE: ./reusable/popups/ErrorInFormPopup.tsx



var ErrorInFormPopup = function(param) {
    var open = param.open, onClose = param.onClose;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassicPopUp/* default */.Z, {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorPopIcon, {}),
        open: open,
        title: "מצטערים, משהו השתבש",
        text: "הפנייה לא נשלחה אלינו, כדאי לנסות שוב",
        onClose: onClose
    });
};
/* harmony default export */ var popups_ErrorInFormPopup = (ErrorInFormPopup);


/***/ }),

/***/ 63358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13328);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57833);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  position: relative;\n  height: 150px;\n  ",
        " {\n    height: 270px;\n    ",
        ";\n  }\n  img {\n    object-fit: cover;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var StyledImageContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "ImageContainer__StyledImageContainer",
    componentId: "sc-4c5af28c-0"
})(_templateObject(), function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.$collapseOpen && "margin-top: 63px";
});
var ImageContainer = function(param) {
    var src = param.src;
    var collapseOpen = (0,store__WEBPACK_IMPORTED_MODULE_3__/* .useTypedSelector */ .ix)(function(state) {
        return state.collapseLayout;
    }).collapseOpen;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledImageContainer, {
        $collapseOpen: collapseOpen,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
            src: src,
            layout: "fill",
            priority: true,
            alt: "page-cover-img",
            role: "presentation",
            "aria-hidden": "true"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ImageContainer);


/***/ }),

/***/ 45732:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43832);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22318);
/* harmony import */ var common_BreadCrumbs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15738);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57833);
/* harmony import */ var theme_shared__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6089);
/* harmony import */ var _ImageContainer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63358);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  padding-top: ",
        "px;\n  flex-direction: column;\n  background-color: ",
        ";\n  ",
        " {\n    padding-top: ",
        "px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  margin-bottom: 60px;\n  flex-direction: column;\n  width: 100%;\n  padding-right: 20px;\n  padding-left: 20px;\n  ",
        " {\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 80px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 40px 20px;\n  padding-bottom: ",
        ";\n  ",
        " {\n    padding: 40px 20px 20px;\n    max-width: 800px;\n    padding-bottom: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: right;\n  ",
        " {\n    text-align: center;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: right;\n  margin-top: 10px;\n  ",
        " {\n    margin-top: 20px;\n    text-align: center;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}






var StyledPageWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "InnerPageWrapper__StyledPageWrapper",
    componentId: "sc-df466e4e-0"
})(_templateObject(), theme_shared__WEBPACK_IMPORTED_MODULE_3__/* .HEADER_HEIGHT_M */ .Gi, function(p) {
    return p.theme.colors.lightGrey;
}, function(p) {
    return p.theme.breakpoints.up("md");
}, theme_shared__WEBPACK_IMPORTED_MODULE_3__/* .HEADER_HEIGHT_D */ .gw);
var StyledPageWrap = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "InnerPageWrapper__StyledPageWrap",
    componentId: "sc-df466e4e-1"
})(_templateObject1());
var StyledContentWrap = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    displayName: "InnerPageWrapper__StyledContentWrap",
    componentId: "sc-df466e4e-2"
})(_templateObject2(), function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledHeader = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    displayName: "InnerPageWrapper__StyledHeader",
    componentId: "sc-df466e4e-3"
})(_templateObject3(), function(p) {
    return "".concat(p.$paddingBottom && p.$paddingBottom, "px");
}, function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return "".concat(p.$paddingBottom && p.$paddingBottom, "px !important");
});
var StyledHeadline = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z).attrs({
    variant: "h2",
    component: "h1"
}).withConfig({
    displayName: "InnerPageWrapper__StyledHeadline",
    componentId: "sc-df466e4e-4"
})(_templateObject4(), function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledSubtitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z).withConfig({
    displayName: "InnerPageWrapper__StyledSubtitle",
    componentId: "sc-df466e4e-5"
})(_templateObject5(), function(p) {
    return p.theme.breakpoints.up("md");
});
var InnerPageWrapper = function(param) {
    var imgUrl = param.imgUrl, title = param.title, subtitle = param.subtitle, children = param.children, breadCrumbName = param.breadCrumbName, page = param.page, paddingBottom = param.paddingBottom, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledPageWrapper, {
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledPageWrap, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_ImageContainer__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    src: imgUrl
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(common_BreadCrumbs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    name: breadCrumbName,
                    page: page
                }),
                title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledHeader, {
                    $paddingBottom: paddingBottom,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledHeadline, {
                            children: [
                                " ",
                                title,
                                " "
                            ]
                        }),
                        subtitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledSubtitle, {
                            dangerouslySetInnerHTML: {
                                __html: subtitle
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledContentWrap, {
                    children: children
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (InnerPageWrapper);


/***/ }),

/***/ 58397:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ insurance; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./common/SeoMetaData.tsx
var SeoMetaData = __webpack_require__(25384);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./common/MediaQueries.tsx + 5 modules
var MediaQueries = __webpack_require__(57402);
// EXTERNAL MODULE: ./common/bit/NextLink.tsx
var NextLink = __webpack_require__(60687);
// EXTERNAL MODULE: ./node_modules/react-string-replace/index.js
var react_string_replace = __webpack_require__(59632);
var react_string_replace_default = /*#__PURE__*/__webpack_require__.n(react_string_replace);
// EXTERNAL MODULE: ./reusable/wrappers/InnerPageWrapper.tsx
var InnerPageWrapper = __webpack_require__(45732);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
// EXTERNAL MODULE: ./theme/shared.tsx
var shared = __webpack_require__(6089);
;// CONCATENATED MODULE: ./components/pages/insurance/InsuranceData.ts
var insuranceData = [
    {
        iconPath: "/icons/insurances/4.svg",
        title: "אבדן או גניבה",
        text: "במקרה של אובדן מוחלט או גניבה של רכב שגילו מעל 12 חודשים ועד 36 חודשים, יינתן פיצוי מיוחד נוסף בעת רכישת רכב חדש מהיבואנית דלק מוטורס."
    },
    {
        iconPath: "/icons/insurances/3.svg",
        title: "כיסוי רכב",
        text: "כיסוי של ״חדש תמורת ישן״ לרכב שגילו עד 12 חודשים מיום עלייתו לכביש- במקרה של אובדן מוחלט או גניבה, בעת רכישת רכב חדש מהיבואנית דלק מוטורס תספק דלק מוטורס רכב חדש, עד לשווי כחדש של הרכב המבוטח ללא הפחתות."
    },
    {
        iconPath: "/icons/insurances/2.svg",
        title: "שימוש חלפים",
        text: "שימוש בחלפים מקוריים חדשים של מאזדה לרכב שגילו עד 24 חודשים במרכזי השירות המורשים הנכללים בהסדר בלבד."
    },
    {
        iconPath: "/icons/insurances/6.svg",
        title: "השתתפות עצמית",
        text: "השתתפות עצמית מוקטנת בתיקון במרכזי השירות המורשים מטעם דלק מוטורס הנכללים בהסדר."
    },
    {
        iconPath: "/icons/insurances/8.svg",
        title: "כיסוי לצד שלישי",
        text: "כיסוי לצד שלישי בגבול אחריות מוגדל של 1,000,000 ₪"
    },
    {
        iconPath: "/icons/insurances/1.svg",
        title: "תיקון המכונית",
        text: "תיקון המכונית במרכזי השירות המורשים מטעם דלק מוטורס הנכללים בהסדר."
    },
    {
        iconPath: "/icons/insurances/7.svg",
        title: "שירותים",
        text: "חבילת שירותים לרכב לרבות רכב חלופי, שירותי דלק ועוד."
    },
    {
        iconPath: "/icons/insurances/5.svg",
        title: "נזק",
        text: "נזק של מעל 50% ייחשב לנזק מוחלט"
    },
    {
        iconPath: "/icons/insurances/9.svg",
        title: "הרחבות",
        text: "הרחבות וכיסויים נוספים."
    }, 
];

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./api/index.ts + 2 modules
var api = __webpack_require__(71537);
// EXTERNAL MODULE: ./common/bit/form/FormikForm.tsx
var FormikForm = __webpack_require__(95055);
// EXTERNAL MODULE: ./common/bit/utils/utmParams.ts
var utmParams = __webpack_require__(21172);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./reusable/formsComp/FormInput.tsx
var FormInput = __webpack_require__(77498);
// EXTERNAL MODULE: ./reusable/formsComp/FormSuccessState.tsx
var FormSuccessState = __webpack_require__(27047);
// EXTERNAL MODULE: ./reusable/popups/ErrorInFormPopup.tsx + 1 modules
var ErrorInFormPopup = __webpack_require__(87183);
// EXTERNAL MODULE: ./common/bit/form/FormikSchema.ts
var FormikSchema = __webpack_require__(46363);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
;// CONCATENATED MODULE: ./components/pages/insurance/SchemaInsurance.ts


var schemaInsurance = es/* object */.Ry({
    firstName: es/* string */.Z_().matches(FormikSchema/* regex.singleName */.Sz.singleName, "יש להזין אותיות בעברית/ באנגלית").min(2, "יש להזין לפחות שתי אותיות תחת השם").max(50, "יש להזין עד 50 תווים בלבד").required(FormikSchema/* required.default */.C1["default"]),
    lastName: es/* string */.Z_().matches(FormikSchema/* regex.singleName */.Sz.singleName, "יש להזין אותיות בעברית/ באנגלית").min(2, "יש להזין לפחות שתי אותיות תחת השם").max(50, "יש להזין עד 50 תווים בלבד").required(FormikSchema/* required.default */.C1["default"]),
    phoneNumber: es/* string */.Z_().matches(FormikSchema/* regex.phoneNumber */.Sz.phoneNumber, "טלפון אינו תקין").required("יש להזין מספר נייד תקין").max(10, "יש להזין עד 10 ספרות בלבד"),
    email: es/* string */.Z_().email("כתובת מייל אינה תקינה").required(FormikSchema/* required.default */.C1["default"]),
    message: es/* string */.Z_().max(500, "יש להזין עד 500 תווים בלבד")
}).defined();
var initialFormStatesInsurance = {
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    message: ""
};
/* harmony default export */ var SchemaInsurance = (schemaInsurance);

;// CONCATENATED MODULE: ./components/pages/insurance/InsuranceForm.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 40px;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 2px;\n  width: 100%;\n  ",
        " {\n    width: 660px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 20px 0px;\n  ",
        " {\n    width: 320px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  margin-top: auto;\n  gap: 2px;\n  ",
        " {\n    flex-direction: row;\n    column-gap: 16px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 100%;\n  width: 100%;\n  ",
        " {\n    max-width: 460px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    p {\n      width: 400px;\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  margin-left: auto;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}













var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "InsuranceForm__StyledWrapper",
    componentId: "sc-bbc3a0e-0"
})(_templateObject());
var StyledFormDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "InsuranceForm__StyledFormDiv",
    componentId: "sc-bbc3a0e-1"
})(_templateObject1(), function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    displayName: "InsuranceForm__StyledButton",
    componentId: "sc-bbc3a0e-2"
})(_templateObject2(), function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledRowCol = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "InsuranceForm__StyledRowCol",
    componentId: "sc-bbc3a0e-3"
})(_templateObject3(), function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "InsuranceForm__StyledWrap",
    componentId: "sc-bbc3a0e-4"
})(_templateObject4(), function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledRequiredFields = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
    variant: "body2"
}).withConfig({
    displayName: "InsuranceForm__StyledRequiredFields",
    componentId: "sc-bbc3a0e-5"
})(_templateObject5(), function(p) {
    return p.theme.colors.mazdaRed;
});
var FormStatus;
(function(FormStatus) {
    FormStatus["Normal"] = "normal";
    FormStatus["Success"] = "success";
    FormStatus["Error"] = "error";
})(FormStatus || (FormStatus = {}));
var InsuranceForm = function() {
    var ref = (0,react.useState)(FormStatus.Normal), formStatus = ref[0], setFormStatus = ref[1];
    var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
                children: [
                    formStatus === FormStatus.Success && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormSuccessState/* default */.Z, {}),
                    (formStatus === FormStatus.Error || formStatus === FormStatus.Normal) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(shared/* TypographyCenter */.kc, {
                                variant: "h2",
                                $mobileRtl: true,
                                $mt: "40px",
                                children: [
                                    "לקבלת הצעה משתלמת לביטוח הרכב, ",
                                    isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "צריך רק להשאיר פרטים ונשמח לחזור בהקדם"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormikForm/* default */.Z, {
                                validationSchema: SchemaInsurance,
                                initialValues: initialFormStatesInsurance,
                                onSubmit: function() {
                                    var _ref = (0,_async_to_generator/* default */.Z)(function(values) {
                                        var ref, ref1, utmValues, formResponse;
                                        return (0,tslib_es6.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    utmValues = (0,utmParams/* getUtmParamsAsKeyValueList */.U)();
                                                    return [
                                                        4,
                                                        (0,api/* postContactSubmitInsurance */.VC)({
                                                            subjectId: 0,
                                                            licensePlate: "",
                                                            carModelId: 0,
                                                            showRoomId: 0,
                                                            firstName: values.firstName,
                                                            lastName: values.lastName,
                                                            phone: values.phoneNumber,
                                                            fax: "",
                                                            email: values.email,
                                                            otherPhone: "",
                                                            description: values.message,
                                                            approveMailingList: false,
                                                            contactSource: isDesktop ? "Pc" : "Mobile",
                                                            utmValues: utmValues,
                                                            sid: (window === null || window === void 0 ? void 0 : (ref = window.__ctm) === null || ref === void 0 ? void 0 : (ref1 = ref.config) === null || ref1 === void 0 ? void 0 : ref1.sid) || "",
                                                            formName: "Mazda_insurance_form"
                                                        })
                                                    ];
                                                case 1:
                                                    formResponse = _state.sent();
                                                    if (formResponse === null || formResponse === void 0 ? void 0 : formResponse.data) {
                                                        setFormStatus(FormStatus.Success);
                                                    } else {
                                                        setFormStatus(FormStatus.Error);
                                                    }
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    });
                                    return function(values) {
                                        return _ref.apply(this, arguments);
                                    };
                                }(),
                                render: function(formik) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFormDiv, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRequiredFields, {
                                                children: "* שדות חובה"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledRowCol, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInput/* default */.Z, {
                                                        name: "firstName",
                                                        label: "שם פרטי",
                                                        required: true,
                                                        autoComplete: "given-name"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInput/* default */.Z, {
                                                        name: "lastName",
                                                        label: "שם משפחה",
                                                        required: true,
                                                        autoComplete: "family-name"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledRowCol, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInput/* default */.Z, {
                                                        name: "phoneNumber",
                                                        label: "טלפון נייד",
                                                        autoComplete: "tel-national",
                                                        required: true,
                                                        type: "tel"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInput/* default */.Z, {
                                                        name: "email",
                                                        label: "כתובת מייל",
                                                        autoComplete: "email",
                                                        required: true,
                                                        type: "email"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInput/* default */.Z, {
                                                name: "message",
                                                label: "?איך נוכל לעזור",
                                                multiline: true,
                                                minRows: 4
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrap, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                                                        disabled: formik.isSubmitting,
                                                        fullWidth: true,
                                                        variant: "text",
                                                        type: "submit",
                                                        children: "שליחה"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* TypographyCenter */.kc, {
                                                        variant: "body2",
                                                        $mobileRtl: true,
                                                        children: "הפרטים יועברו לדלק מוטורס ביטוח וישמשו רק כדי ליצור איתך קשר. אל דאגה, לא נשמור אותם ולא נעשה בהם כל שימוש נוסף"
                                                    })
                                                ]
                                            })
                                        ]
                                    });
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorInFormPopup/* default */.Z, {
                open: formStatus === FormStatus.Error,
                onClose: function() {
                    return setFormStatus(FormStatus.Normal);
                }
            })
        ]
    });
};
/* harmony default export */ var insurance_InsuranceForm = (InsuranceForm);

;// CONCATENATED MODULE: ./components/pages/insurance/InsurancePage.tsx

function InsurancePage_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  margin: 20px 0px;\n  ",
        " {\n    padding: 45px 0px;\n    width: 100%;\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr;\n    column-gap: auto;\n    justify-items: center;\n  }\n"
    ]);
    InsurancePage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function InsurancePage_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding: 16px;\n  gap: 16px;\n  ",
        " {\n    flex-direction: column;\n    align-items: center;\n    width: 248px;\n  }\n  ",
        " {\n    /* not last child */\n    &:not(:last-child) {\n      border-bottom: 0.5px solid ",
        ";\n    }\n    padding: 25px 10px;\n  }\n"
    ]);
    InsurancePage_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function InsurancePage_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-decoration: underline;\n  color: ",
        ";\n"
    ]);
    InsurancePage_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function InsurancePage_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 15px;\n"
    ]);
    InsurancePage_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function InsurancePage_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  font-family: "OENaPro";\n  line-height: ',
        ";\n"
    ]);
    InsurancePage_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}









var StyledCardsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "InsurancePage__StyledCardsWrapper",
    componentId: "sc-e3e92f97-0"
})(InsurancePage_templateObject(), function(p) {
    return p.theme.colors.white;
}, function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledCardWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "InsurancePage__StyledCardWrap",
    componentId: "sc-e3e92f97-1"
})(InsurancePage_templateObject1(), function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return p.theme.colors.darkGrey;
});
var StyledNextLink = (0,styled_components_browser_esm/* default */.ZP)(NextLink/* default */.Z).withConfig({
    displayName: "InsurancePage__StyledNextLink",
    componentId: "sc-e3e92f97-2"
})(InsurancePage_templateObject2(), function(p) {
    return p.theme.colors.saphire;
});
var StyledDetailsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "InsurancePage__StyledDetailsContainer",
    componentId: "sc-e3e92f97-3"
})(InsurancePage_templateObject3());
var StyledText = (0,styled_components_browser_esm/* default */.ZP)(shared/* TypographyCenter */.kc).withConfig({
    displayName: "InsurancePage__StyledText",
    componentId: "sc-e3e92f97-4"
})(InsurancePage_templateObject4(), function(p) {
    return p.$lineHeight ? "".concat(p.$lineHeight, "%") : "";
});
var InsurancePage = function() {
    var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(InnerPageWrapper/* default */.Z, {
        title: "ביטוח בתנאים מיוחדים ללקוחות מאזדה",
        imgUrl: isDesktop ? "/img/insurance.jpg" : "/img/insurancemobile.jpg",
        breadCrumbName: "Insurance",
        paddingBottom: "0",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledText, {
                variant: "body1",
                $mobileRtl: true,
                $mb: "26px",
                $fontSize: "20px",
                children: "באמצעות דלק מוטורס סוכנות לביטוח (2003) בע״מ"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledText, {
                variant: "body1",
                $mobileRtl: true,
                children: "כל מה שצריך בשביל ליהנות מראש שקט לאורך כל הדרך."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledText, {
                variant: "h2",
                $mobileRtl: true,
                $fontSize: "18px",
                children: "תכנית הביטוח מיועדת לרוכשי מכוניות מתוצרת מאזדה וכוללת בין היתר:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCardsWrapper, {
                children: insuranceData.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCardWrap, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* StyledSvgIcon */.vV, {
                                src: item.iconPath,
                                w: 30,
                                h: 30,
                                role: "presentation",
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledText, {
                                        variant: "h3",
                                        $mobileRtl: true,
                                        children: item.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledText, {
                                        variant: "body1",
                                        $lineHeight: 130,
                                        $mobileRtl: true,
                                        children: react_string_replace_default()(item.text, "במרכזי השירות המורשים", function(match, i) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledNextLink, {
                                                href: "/services-centers/?popup=open",
                                                children: match
                                            }, i);
                                        })
                                    })
                                ]
                            })
                        ]
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledText, {
                variant: "h2",
                $mobileRtl: true,
                $fontSize: "20px",
                children: "כפוף לתנאי הפוליסה"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledText, {
                variant: "h2",
                $mt: "10px",
                $mobileRtl: true,
                $fontSize: "18px",
                children: "במקרה של תאונה/גניבה יש לפנות למוקד תביעות של דלק מוטורס ביטוח."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDetailsContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledText, {
                        variant: "body1",
                        $mobileRtl: true,
                        children: [
                            "טלפון:",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledNextLink, {
                                href: "tel:077-7552215",
                                children: "077-7552215"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledText, {
                        variant: "body1",
                        $mobileRtl: true,
                        children: [
                            "פקס:",
                            " ",
                            "153-777-552202"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledText, {
                        variant: "body1",
                        $mobileRtl: true,
                        children: [
                            "דואל:",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledNextLink, {
                                href: "mailto:service1@delekmotors.co.il",
                                children: "service1@delekmotors.co.il"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(insurance_InsuranceForm, {})
        ]
    });
};
/* harmony default export */ var insurance_InsurancePage = (InsurancePage);

;// CONCATENATED MODULE: ./src/pages/insurance.tsx



var Insurance = function(param) {
    var seo = param.seo;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SeoMetaData/* default */.ZP, {
                data: seo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(insurance_InsurancePage, {})
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var insurance = (Insurance);


/***/ }),

/***/ 59632:
/***/ (function(module) {

/* eslint-disable vars-on-top, no-var, prefer-template */
var isRegExp = function (re) { 
  return re instanceof RegExp;
};
var escapeRegExp = function escapeRegExp(string) {
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
    reHasRegExpChar = RegExp(reRegExpChar.source);

  return (string && reHasRegExpChar.test(string))
    ? string.replace(reRegExpChar, '\\$&')
    : string;
};
var isString = function (value) {
  return typeof value === 'string';
};
var flatten = function (array) {
  var newArray = [];

  array.forEach(function (item) {
    if (Array.isArray(item)) {
      newArray = newArray.concat(item);
    } else {
      newArray.push(item);
    }
  });

  return newArray;
};

/**
 * Given a string, replace every substring that is matched by the `match` regex
 * with the result of calling `fn` on matched substring. The result will be an
 * array with all odd indexed elements containing the replacements. The primary
 * use case is similar to using String.prototype.replace except for React.
 *
 * React will happily render an array as children of a react element, which
 * makes this approach very useful for tasks like surrounding certain text
 * within a string with react elements.
 *
 * Example:
 * matchReplace(
 *   'Emphasize all phone numbers like 884-555-4443.',
 *   /([\d|-]+)/g,
 *   (number, i) => <strong key={i}>{number}</strong>
 * );
 * // => ['Emphasize all phone numbers like ', <strong>884-555-4443</strong>, '.'
 *
 * @param {string} str
 * @param {RegExp|str} match Must contain a matching group
 * @param {function} fn
 * @return {array}
 */
function replaceString(str, match, fn) {
  var curCharStart = 0;
  var curCharLen = 0;

  if (str === '') {
    return str;
  } else if (!str || !isString(str)) {
    throw new TypeError('First argument to react-string-replace#replaceString must be a string');
  }

  var re = match;

  if (!isRegExp(re)) {
    re = new RegExp('(' + escapeRegExp(re) + ')', 'gi');
  }

  var result = str.split(re);

  // Apply fn to all odd elements
  for (var i = 1, length = result.length; i < length; i += 2) {
    /** @see {@link https://github.com/iansinnott/react-string-replace/issues/74} */
    if (result[i] === undefined || result[i - 1] === undefined) {
      console.warn('reactStringReplace: Encountered undefined value during string replacement. Your RegExp may not be working the way you expect.');
      continue;
    }

    curCharLen = result[i].length;
    curCharStart += result[i - 1].length;
    result[i] = fn(result[i], i, curCharStart);
    curCharStart += curCharLen;
  }

  return result;
}

module.exports = function reactStringReplace(source, match, fn) {
  if (!Array.isArray(source)) source = [source];

  return flatten(source.map(function(x) {
    return isString(x) ? replaceString(x, match, fn) : x;
  }));
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4245,2669,4839,9774,2888,179], function() { return __webpack_exec__(68214); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);